import { TAGS } from "../constants";
import { DetailedEmployee, Employee, EmployeeUpdate, UserRole } from "../types";
import { api } from "./api";

export const employeeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createEmployee: builder.mutation<
      Employee,
      {
        user: { email: string; password: string };
        updates: EmployeeUpdate;
      }
    >({
      query: (body) => ({
        url: `/api/employees`,
        method: "POST",
        body,
      }),
    }),

    getEmployee: builder.query<DetailedEmployee, string>({
      query: (id) => ({
        url: `/api/employees/${id}`,
        method: "GET",
      }),
      providesTags(_result, _error, arg) {
        return [{ type: TAGS.EMPLOYEE, id: arg }];
      },
    }),

    getEmployeeRoles: builder.query<UserRole[], string>({
      query: (id) => ({
        url: `/api/employees/${id}/roles`,
        method: "GET",
      }),
      providesTags(_result, _error, arg) {
        return [{ type: TAGS.EMPLOYEE_ROLES, id: arg }];
      },
    }),

    assignRoles: builder.mutation<
      UserRole[],
      { user_id: string; roles: number[] }
    >({
      query: (body) => ({
        url: `/api/employees/${body.user_id}/roles`,
        method: "POST",
        body,
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        dispatch(
          employeeApi.util.updateQueryData(
            "getEmployeeRoles",
            arg.user_id,
            (draft) => {
              (draft || []).push(...data);
            }
          )
        );
      },
    }),

    removeRole: builder.mutation<
      UserRole,
      { user_id: string; role_id: number }
    >({
      query: ({ user_id, role_id }) => ({
        url: `/api/employees/${user_id}/roles/${role_id}`,
        method: "DELETE",
      }),

      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        const patch = dispatch(
          employeeApi.util.updateQueryData(
            "getEmployeeRoles",
            arg.user_id,
            (draft) => {
              const index = draft.findIndex((r) => r.id === arg.role_id);
              if (index >= 0) {
                draft.splice(index, 1);
              }
            }
          )
        );

        queryFulfilled.catch(patch.undo);
      },
    }),
  }),
});

export const {
  useCreateEmployeeMutation,
  useGetEmployeeQuery,
  useAssignRolesMutation,
  useRemoveRoleMutation,
  useGetEmployeeRolesQuery,
} = employeeApi;
